import SiafLiteApiRepository from "../../external/siafLiteApi";

class TipoDesoneracaoService {
  constructor() {
    this.urlBase = "/fiscal/tipo-desoneracao";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll() {
    return new SiafLiteApiRepository(this.urlBaseEvent).get();
  }
}

export default TipoDesoneracaoService;
